/**
 * Converts HTML inside .metafield-rich_text_field (h2 + next p pairs) into
 * accordions that match the structure and behaviour of collection-accordions-seo.
 * Uses section-accordions.css and the theme's collapsible-elements component.
 */
(function () {
  'use strict';

  const ICON_TOGGLE_PLUS =
    '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-toggle-plus" viewBox="0 0 192 192"><path d="M30 96h132M96 30v132" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const ICON_TOGGLE_MINUS =
    '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-toggle-minus" viewBox="0 0 192 192"><path d="M30 96h132" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  /**
   * Parse a container's HTML and return pairs of { title: string, textHtml: string }
   * from each <h2> and its immediately following <p>.
   */
  function parseMetafieldAccordionPairs(container) {
    const pairs = [];
    const temp = document.createElement('div');
    temp.innerHTML = container.innerHTML;
    const h2s = temp.querySelectorAll('h2');

    h2s.forEach(function (h2) {
      const title = (h2.textContent || '').trim();
      const next = h2.nextElementSibling;
      const textHtml = next && next.tagName === 'P' ? next.innerHTML : '';

      if (title) {
        pairs.push({ title: title, textHtml: textHtml });
      }
    });

    return pairs;
  }

  /**
   * Build one accordion item as HTML string.
   */
  function buildAccordionItemHtml(pair, index, sectionId) {
    const itemId = 'Accordion--metafield-' + index;
    const controlsId = 'Accordions-item--metafield-' + index + '-' + sectionId;
    const titleEscaped = escapeHtml(pair.title);

    return (
      '<li id="' + itemId + '" class="accordion__item">' +
      '<button type="button" class="accordion__title" aria-expanded="false" aria-controls="' + controlsId + '" data-collapsible-trigger>' +
      '<span class="accordion__title-text">' + titleEscaped + '</span>' +
      ICON_TOGGLE_PLUS +
      ICON_TOGGLE_MINUS +
      '</button>' +
      '<div class="accordion__text-wrapper" id="' + controlsId + '" data-collapsible-container>' +
      '<div class="accordion__text rte" data-collapsible-content>' + pair.textHtml + '</div>' +
      '</div>' +
      '</li>'
    );
  }

  /**
   * Build full accordion markup as HTML string (two-column layout like snippet).
   */
  function buildAccordionsHtml(pairs, sectionId) {
    const firstColumnCount = Math.ceil(pairs.length / 2);

    const firstColumnItems = pairs
      .slice(0, firstColumnCount)
      .map(function (pair, index) {
        return buildAccordionItemHtml(pair, index, sectionId);
      })
      .join('');

    const secondColumnItems = pairs
      .slice(firstColumnCount)
      .map(function (pair, index) {
        return buildAccordionItemHtml(pair, firstColumnCount + index, sectionId);
      })
      .join('');

    return (
      '<div class="wrapper">' +
      '<collapsible-elements class="accordion__content" data-collapsible-single>' +
      '<div class="accordion__columns">' +
      '<div class="accordion__column">' +
      '<ul class="accordion__list">' + firstColumnItems + '</ul>' +
      '</div>' +
      '<div class="accordion__column">' +
      '<ul class="accordion__list accordion__list--two-columns">' + secondColumnItems + '</ul>' +
      '</div>' +
      '</div>' +
      '</collapsible-elements>' +
      '</div>'
    );
  }

  /**
   * Replace content of .metafield-rich_text_field with accordion markup.
   */
  function convertMetafieldRichTextToAccordions() {
    const container = document.querySelector('.rich_text_field-collection_faqs');
    if (!container) return;

    const sectionId = container.getAttribute('data-section-id') || 'metafield-accordions';
    const pairs = parseMetafieldAccordionPairs(container);
    if (pairs.length === 0) return;

    container.innerHTML = buildAccordionsHtml(pairs, sectionId);
    container.classList.remove('loading');
  }

  convertMetafieldRichTextToAccordions();
})();
